import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
   setResponseAlertData,
   clearResponseAlertData,
} from '../../redux/slices/ResponseAlertSlice';
import {setSignIn} from '../../redux/slices/AuthSlice';
import {useNavigation} from '@react-navigation/native';
import {NavigationAction} from '@react-navigation/native';
import {
   setIsDashboardRefreshRequired,
   selectDashboardRefresh,
} from '../../redux/slices/DashboardRefreshSlice';
import {selectLandscapeSmallWebView} from '../../redux/slices/ScreenOrientationSlice';
import {logoutHandler} from '../../service/network_access';
import {FONT_FAMILY_BOLD, FONT_FAMILY_REGULAR} from '../../utils/utils';
import {Text, View} from 'react-native';

const CustomAlert = ({
   title = '',
   message = '',
   callbackType = '',
   navigation = null,
   onOK = () => {},
}) => {
   const [isOpen, setIsOpen] = useState(true);
   const dispatch = useDispatch();
   const isDashboardRefreshRequired = useSelector(selectDashboardRefresh);
   const navigations = useNavigation();

   const handleOK = () => {
      dispatch(clearResponseAlertData());
      if (callbackType === 'TOKEN_EXPIRED') {
         (() => {
            const user = {
               isLoggedIn: false,
               userName: '',
            };
            //dispatch(setSignIn(user));
            logoutHandler();
         })();
         navigation?.reset({
            index: 0,
            routes: [
               {
                  name: 'Login',
               },
            ],
         });
      }
      if (['UNLOCK_ACCOUNT', 'RESET_ACCOUNT'].includes(callbackType)) {
         //navigations.pop(2);
         /* dispatch(
            setIsDashboardRefreshRequired({
               isDashboardRefreshRequired: !isDashboardRefreshRequired,
            }),
         ); */
         navigations.navigate('DashboardScreen');
      }
      if (callbackType === 'GO_BACK') {
         navigations.goBack();
      }
      setIsOpen(false);
      onOK();
   };
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   return (
      isOpen && (
         <div
            style={{
               ...styles.container,
               // transform: isLandscapeSmallWebView ? 'rotate(90deg)' : null,
               // left: isLandscapeSmallWebView ? '-50vh' : null,
            }}>
            <View style={styles.alertBox}>
               <Text style={styles.titleStyle}>{title}</Text>
               <Text style={styles.messageStyle}>{message}</Text>
               <div style={styles.buttonContainer}>
                  <button onClick={handleOK} style={styles.buttonStyles}>
                     OK
                  </button>
               </div>
            </View>
         </div>
      )
   );
};

const styles = {
   container: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      backgroundColor: 'transparent',
      display: 'flex',
      justifyContent: 'center',
      minWidth: '100vw',
      zIndex: 9998,
      minHeight: '100vh',
   },
   alertBox: {
      width: 280,
      minHeight: 128,
      backgroundColor: '#f5f5f5',
      borderRadius: 4,
      alignSelf: 'center',
      paddingVertical: 10,
      paddingHorizontal: 16,
   },
   titleStyle: {
      fontSize: 20,
      fontWeight: '700',
      marginVertical: 8,
      fontFamily: FONT_FAMILY_BOLD,
   },
   messageStyle: {
      marginVertical: 8,
      fontSize: 16,
      fontFamily: FONT_FAMILY_REGULAR,
   },
   buttonContainer: {
      textAlign: 'right',
      position: 'relative',
      bottom: '-8px',
   },
   buttonStyles: {
      margin: '8px 0',
      backgroundColor: '#f5f5f5',
      color: 'green',
      border: 'none',
      fontSize: '18px',
   },
};
export default CustomAlert;
